import {getSelectedLixilDateObject} from "../appointmentLogic/appointmentActions";

export const getSaveAppointmentData = (store, jobId) => {
  const {appointmentDate, appointmentTime, appointmentTimeSlot, availableAppointmentDates} = store.appointmentState;
  const {useLixilCalendar} = store.fabricatorState;

  let timeToPass = appointmentTime;

  if (appointmentDate && useLixilCalendar && appointmentTimeSlot) {
    const appDate = new Date(appointmentDate);
    const selectedLixilDateObject = getSelectedLixilDateObject(appDate, availableAppointmentDates);
    if (selectedLixilDateObject) {
      const timeSlotObject = selectedLixilDateObject.salesRepsInSlots.find(timeSlotObject => timeSlotObject.timeSlot === appointmentTimeSlot)
      if (timeSlotObject && timeSlotObject.slotStartTime) {
        timeToPass = timeSlotObject.slotStartTime;
      }
    }
  }

  const splittedTime = timeToPass.split(":00");
  const am = splittedTime[1] && splittedTime[1].toLowerCase().includes("am");

  let date = ""+appointmentDate.getDate();
  let month = ""+(appointmentDate.getMonth() + 1); // +1 because getMonth returns starting from 0 (January is 0)
  let year = ""+appointmentDate.getFullYear();

  date = date.length === 1 ? "0" + date : date;
  month = month.length === 1 ? "0" + month : month;

  const scheduleData = {
    scheduleEntryData: {
      // date: "03/02/2024",
      date: `${month}/${date}/${year}`,
      time: `${splittedTime[0].length === 1 ? "0" + splittedTime[0] : splittedTime[0]}:00`, // 1:00 -> 01:00
      am: am,
      duration: 60,
      alert: 30,
      appointmentType: 'Quote'
    },
    jobId,
    jobIdType: 'JobQuote'
  };

  console.log("scheduleData", scheduleData);
  return scheduleData
}
